import { Link } from '@/ui'
import { PLAN_CHANGE_PATH } from '@/features/user/settings/sections/plan-change/lib/usePlanChangeEntry'

export const ComparePlansLink = () => (
  <Link href={PLAN_CHANGE_PATH} className="mt-8">
    View all benefits and compare plans
  </Link>
)
